module.exports = __webpack_public_path__ + "static/atb-5eea36f2bbd8ff680a30439cc3f798d3.png";